import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { NgIf } from '@angular/common';
import { ApiService } from '@portal-core/auth/services/api.service';
import { LayoutService } from '@portal-core/layout/services/layout.service';
import { MatToolbar } from '@angular/material/toolbar';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuContent, MatMenuItem } from '@angular/material/menu';

@Component({
    selector: 'mc-navbar-help-button',
    templateUrl: './navbar-help-button.component.html',
    styleUrls: ['./navbar-help-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatToolbar, MatButton, MatMenuTrigger, MatMenu, MatMenuContent, MatMenuItem, NgIf]
})
export class NavbarHelpButtonComponent {
  readonly apiService = inject(ApiService);
  private readonly layoutService = inject(LayoutService);

  @Input() appVersionAndBuildDate?: string = '';

  onAboutClicked() {
    this.layoutService.emitOpenAboutDialog();
  }
}
